// File yang berisi daftar meta keywords
const metaKeywordsContent = `
Rekanata Konstruksi,
Kontraktor Profesional,
Kontraktor Bangunan,
Jasa Kontraktor,
Kontraktor Rumah Minimalis,
Kontraktor Rumah Klasik,
Kontraktor Rumah Jepang,
Kontraktor Rumah Japandi,
Kontraktor Rumah Skandinavian,
Kontraktor Rumah Kontemporer,
Kontraktor Rumah Korea,
Kontraktor Rumah Industrial,
Kontraktor Rumah Mediterania,
Kontraktor Rumah Rustik,
Kontraktor Rumah Tropis,
Kontraktor Rumah Attic,
Kontraktor Rumah Modern,
Kontraktor Interior Minimalis,
Kontraktor Interior Klasik,
Kontraktor Interior Jepang,
Kontraktor Interior Japandi,
Kontraktor Interior Skandinavian,
Kontraktor Interior Kontemporer,
Kontraktor Interior Korea,
Kontraktor Interior Industrial,
Kontraktor Interior Mediterania,
Kontraktor Interior Rustik,
Kontraktor Interior Tropis,
Kontraktor Interior Attic,
Kontraktor Interior Modern,
Jasa Renovasi Rumah,
Kontraktor Bangunan Jakarta,
Kontraktor Bangunan Bandung,
Kontraktor Rumah Surabaya,
Kontraktor Interior Jakarta,
Kontraktor Interior Bandung,
Desain Rumah Minimalis,
Jasa Renovasi Interior,
Kontraktor Pembangunan Rumah,
Kontraktor Renovasi Rumah Jakarta,
Kontraktor Renovasi Rumah Bandung,
Jasa Renovasi Bangunan,
Penyedia Jasa Kontraktor Rumah,
Desain Rumah Modern,
Jasa Arsitek dan Kontraktor,
Kontraktor Bangunan Terpercaya,
Jasa Kontraktor Terbaik,
Kontraktor Rumah Pekerjaan Konstruksi,
Kontraktor Terbaik di Jakarta,
Kontraktor Profesional Indonesia,
Desain Rumah Mewah,
Pembangunan Rumah Skandinavian,
Kontraktor untuk Pembangunan Ruko,
Kontraktor Rumah Komersial,
Kontraktor Interior Rumah Mewah,
Jasa Kontraktor Interior Modern,
Kontraktor Renovasi Kantor,
Desain Rumah Kontemporer,
Kontraktor Rumah Tropis Modern,
Kontraktor Rumah Hemat Biaya,
Pembangunan Rumah Cepat dan Berkualitas,
Kontraktor Renovasi Rumah Terpercaya,
Kontraktor Rumah dengan Kualitas Terbaik,
Jasa Renovasi Interior Rumah,
Penyedia Jasa Desain dan Pembangunan,
Kontraktor Rumah dengan Desain Unik,
Arsitek dan Kontraktor Rumah,
Kontraktor Konstruksi Rumah Profesional,
Kontraktor Rumah Berkualitas,
Jasa Arsitektur Rumah,
Renovasi Rumah dengan Kontraktor Terpercaya,
Jasa Kontraktor Bangunan Jakarta,
Kontraktor Interior Profesional,
Desain Rumah Jepang,
Kontraktor Rumah Modern Minimalis,
Jasa Pembangunan Rumah,
Penyedia Jasa Kontraktor Rumah Berkualitas,
Kontraktor Renovasi Rumah Modern
`;

export default metaKeywordsContent;

